import carouselSlider, { carouselSliderVariants, CarouselSliderVariantsType } from './carousel-slider';
import { CSSStandardProperties } from '../../../types/theme';

const hero = {
  carouselSlider
};

export const heroVariants = {
  carouselSlider: carouselSliderVariants
};

export type HeroVariantsType = 'carouselSlider';

type CombinedHeroVariantsType = CarouselSliderVariantsType;

export interface HeroType {
  /** The Hero subcomponent types. */
  Components: Record<HeroVariantsType, Record<CombinedHeroVariantsType, CSSStandardProperties>>;
  /** The Carousel Slider variants type. */
  CarouselSlider: CarouselSliderVariantsType;
}

export default hero;
